import type { Client2TrackedTranslation } from '@ps/web-core-intl';
import type { Error } from '@ps/web-core-store';

import {
  TXTCLI_Incorrect_Information_Entered,
  TXTCLI_Please_double_check_and_try_to_ELL,
  TXTCLI_Please_specify_3_digit_institu_ELL,
  TXTCLI_Please_specify_5_digit_branch__ELL,
  TXTCLI_Social_Insurance_NumberX_wrong_ELL,
  TXTCLI_Street_address_must_be_at_leas_ELL,
  TXTCLI_The_IBAN_you_have_entered_is_i_ELL,
  TXTCLI_The_SIN_you_entered_does_not_m_ELL,
  TXTCLI_The_bank_routing_number_you_pr_ELL,
  TXTCLI_The_information_entered_in_the_ELL,
  TXTCLI_The_password_you_have_entered__ELL,
  TXTCLI_The_street_address_entered_app_ELL,
  TXTCLI_The_voucher_code_you_have_ente_ELL,
  TXTCLI_Wrong_account_number_format,
  TXTWCL_Ensure_your_CNP_matches_your_d_ELL,
  TXTWCL_Invalid_CNPX_Please_try_againX,
  TXTWCL_Invalid_codeX_Please_try_again_ELL,
  TXTWCL_Please_enter_a_valid_middle_na_ELL,
  TXTWCL_The_card_number_entered_is_not_ELL,
  TXTWCL_Your_CNP_must_be_13_digitsX
} from '../translations';

interface ErrorMessages {
  [key: string]: Client2TrackedTranslation;
}

export const mapErrorCodes = (code: Error['code']) => {
  const mappedMessage: ErrorMessages = {
    TXTCLI_Incorrect_Information_Entered,
    TXTCLI_Please_specify_3_digit_institu_ELL,
    TXTCLI_Please_specify_5_digit_branch__ELL,
    TXTCLI_Social_Insurance_NumberX_wrong_ELL,
    TXTCLI_The_IBAN_you_have_entered_is_i_ELL,
    TXTCLI_The_information_entered_in_the_ELL,
    TXTCLI_The_SIN_you_entered_does_not_m_ELL,
    TXTCLI_The_street_address_entered_app_ELL,
    TXTCLI_The_voucher_code_you_have_ente_ELL,
    TXTCLI_Wrong_account_number_format,
    TXTWCL_Ensure_your_CNP_matches_your_d_ELL,
    TXTWCL_Invalid_CNPX_Please_try_againX,
    TXTWCL_Invalid_codeX_Please_try_again_ELL,
    TXTWCL_The_card_number_entered_is_not_ELL,
    TXTWCL_Please_enter_a_valid_middle_na_ELL,
    TXTWCL_Your_CNP_must_be_13_digitsX,
    TXTCLI_Please_double_check_and_try_to_ELL,
    TXTCLI_The_password_you_have_entered__ELL,
    TXTCLI_Street_address_must_be_at_leas_ELL,
    TXTCLI_The_bank_routing_number_you_pr_ELL
  };

  return (
    (code && mappedMessage[code]?.defaultMessage) ||
    TXTCLI_Incorrect_Information_Entered.defaultMessage
  );
};
